<template>
  <div class="drag-img-multiple">
    <div :class="`img-uploader-wrapper-${idx}`"
         :style="imgWrapperStyle">
      <input
        type="text"
        v-model="filename"
        id="form-control"
        @dragover.prevent
        @dragenter.prevent
        @drop.prevent="onDrop">
      <label for="form-control" :class="`input-img-intext-${this.idx} img-uploader-intext`">
        <div style="user-select:none">
          <i class="material-icons">upload</i>
          <div style="font-size:12px">드래그해서 추가하기</div>
          <div style="font-size:12px;margin:6px 0">또는</div>
          <input-img :url.sync="single_img" :idx="12312321" :mode="1" @update:url="val=>$emit('update:img', val)"></input-img>
          <!--<input-img-multiple :images.sync="multiple_img"
                              :mode="1"
                              @update:images="$emit('update:imgs', multiple_img)"></input-img-multiple>-->
        </div>
      </label>
    </div>
    <div v-show="single_img!==''">
      <div :style="imgStyle(single_img)"
           class="upload-image unselect">
        <i class="material-icons input-img-close" @click.stop.prevent="removeImg">close</i>
      </div>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  import draggable from 'vuedraggable'
  import InputImgMultiple from "./InputImgMultiple";
  import moment from 'moment'
  import InputImg from "./InputImg";
  export default {
    components: {
      InputImg,
      InputImgMultiple,
      draggable
    },
    props: {
      img: {
        type: String
      }
    },
    name: "DragImgSingle",
    created() {
      this.idx = moment().format('SSSS');
      this.single_img = this.img;
    },
    data() {
      return {
        idx: '',
        filename: '',
        single_img: [],
        limit_files: []
      }
    },
    mounted() {
      $(`.img-uploader-wrapper-${this.idx}`)
        .on("dragover", this.dragOver)
        .on("dragleave", this.dragOver)
        .on("drop", this.uploadFiles);
    },
    watch: {
      img(val) {
        this.single_img = val;
      }
    },
    computed: {
      imgWrapperStyle() {
        return {
          width: '175px',
          maxWidth: '554px',
          height: '175px',
          position: 'relative',
          backgroundColor: '#fff',
          display: 'flex',
          marginBottom: '10px',
          flexShrink: 0,
          cursor: 'pointer',
          borderRadius: '8px',
          border: '2px dashed #ccc'
        }
      }
    },
    methods: {
      changeDraggable() {
        this.$emit('update:img', this.single_img);
      },
      imgStyle(img) {
        let url = this.image(img);
        let url_arr = url.split('.');
        if (url_arr[0].split('//')[1] === "launchpack-storage") {
          url_arr[url_arr.length - 2] = `${url_arr[url_arr.length - 2]}_thumb`;
          url = url_arr.join('.');
        }
        return {
          position: 'relative',
          backgroundImage: `url(${url})`,
          width: '80px',
          height: '80px',
          marginRight: '8px',
          marginBottom: '8px',
          backgroundPosition: 'center',
          backgroundSize: 'cover'
        }
      },
      dragOver(e) {
        e.stopPropagation();
        e.preventDefault();
        // console.log(e)
        if (e.type === "dragover") {
          $(`.drag-img-multiple .img-uploader-wrapper-${this.idx}`).css({
            "background-color": "gray"
          });
          $(`.drag-img-multiple .input-img-intext-${this.idx}`).css({
            "color": 'white'
          })
        } else {
          $(`.drag-img-multiple .img-uploader-wrapper-${this.idx}`).css({
            "background-color": "white"
          });
          $(`.drag-img-multiple .input-img-intext-${this.idx}`).css({
            "color": '#797979'
          })
        }
      },
      uploadFiles(e) {
        e.stopPropagation();
        e.preventDefault();
        this.dragOver(e);

        e.dataTransfer = e.originalEvent.dataTransfer;

        let files = e.target.files || e.dataTransfer.files;
        if(files[0].type.match(/image.*!/)) {
          this.toast('이미지가 아닌 파일이 섞여있습니다.')
          return;
        }
        this.inputImageSingleFile(files[0])
        /*for(let file of files) {
          if(!file.type.match(/image.*!/)) {
            this.toast('이미지가 아닌 파일이 섞여있습니다.')
            return;
          }
        }*/
      },
      onDrop(event) {
        this.inputImageSingleFile(event.dataTransfer.files[0])
        // console.log('drop', event)
      },
      async inputImageSingleFile(file) {
        let res = await this.resolutionCheck(file);
        if (!res && this.limit_files.indexOf(file.name) === -1) {
          this.limit_files.push(file.name);
        }

        // 제한된 파일들이 있을 경우
        if (this.limit_files.length > 0) {
          this.toastTime(`아래 파일을 해상도 2000px 이하로 조정해주세요.` +
            `\n \n ${this.limit_files.join('\n')}`, 10000);
          this.limit_files = [];
        } else {
          this.setupReader(file);
        }

      },
      setupReader(file) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.single_img = e.target.result;
          this.$emit('update:img', this.single_img);
          this.$emit('addImg');
        };
        reader.readAsDataURL(file);
      },
      // 해상도 체크
      async resolutionCheck(file) {
        let reader = new FileReader();
        await reader.readAsDataURL(file);
        const image = new Image();
        await new Promise((resolve, reject) => {
          reader.onload = function (e) {
            image.src = e.target.result;
            resolve(reader.result)
          }
        })

        return await new Promise((resolve, reject) => {
          image.onload = (ie) => {
            const width = ie.target.naturalWidth;
            const height = ie.target.naturalHeight;
            resolve(!(width > 2000 || height > 2000))
          };
        })
      },
      removeImg() {
        this.single_img = '';
        this.$emit('update:img', this.single_img);
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .file-input
    display none

  #form-control
    color transparent
    width 0
    height 0
    border 0
    padding 0
    position absolute

  #form-control:focus
    outline none

  .img-uploader-intext
    text-align center
    margin auto
    width 100%
    color #797979
    position absolute
    top 0
    left 0
    height 100%
    display flex
    align-items center
    justify-content center

  .input-img-close
    display none
    padding 4px 0px
    background-color rgba(255,255,255,0.9)
    font-size 24px
    color #555
    position absolute
    top 0px
    right 0
    line-height 13px

  .upload-image:hover > .input-img-close
    display block

</style>
